"use client"
import React, { useEffect, useState } from "react";
import { HiOutlineXMark } from "react-icons/hi2";

export function Modal({ isOpen, onClose, data, onSubmit }) {
  const [formData, setFormData] = useState({
    yourName: "",
    companyName: "",
    softwareName: "",
    description: "",
    rating: ""
  });
  useEffect(() => {
    if (data) {
      setFormData({
        yourName: data.yourName || "",
        companyName: data.companyName || "",
        softwareName: data.softwareName || "",
        description: data.description || "",
        rating: data.rating || ""
      });
    }
  }, [data]);
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
    // console.log("Form data: -->>>", formData);
    onClose()
  };

  if (!isOpen) return null;

  return (
      <div className="fixed inset-0 opacity-9 text-black bg-opacity-50 backdrop-blur-sm flex justify-center items-center z-50">
      <div className="relative bg-gray-900  rounded-xl shadow-2xl max-w-lg w-full p-8">

        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-300 text-3xl font-bold hover:text-red-500 transition-colors"
        >
           <HiOutlineXMark size={30} />
        </button>

        {/* Modal Title */}
        <h2 className="text-2xl font-semibold mb-6 text-center text-white">
          Edit Review Form
        </h2>

        {/* Form */}
        <form onSubmit={handleSubmit} className="space-y-5">

          {/* Your Name */}
          <div>
            <label className="block text-sm font-medium text-gray-300 mb-1">
              Your Name
            </label>
            <input
              type="text"
              name="yourName"
              value={formData.yourName}
              onChange={handleInputChange}
              className="w-full p-3 rounded-lg bg-gray-800 border border-gray-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 text-white placeholder-gray-400"
              placeholder="Enter your full name"
              required
            />
          </div>

          {/* Company Name */}
          <div>
            <label className="block text-sm font-medium text-gray-300 mb-1">
              Company Name
            </label>
            <input
              type="text"
              name="companyName"
              value={formData.companyName}
              onChange={handleInputChange}
              className="w-full p-3 rounded-lg bg-gray-800 border border-gray-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 text-white placeholder-gray-400"
              placeholder="Enter company name"
              required
            />
          </div>

          {/* Software Name */}
          <div>
            <label className="block text-sm font-medium text-gray-300 mb-1">
              Software Name
            </label>
            <input
              type="text"
              name="softwareName"
              value={formData.softwareName}
              onChange={handleInputChange}
              className="w-full p-3 rounded-lg bg-gray-800 border border-gray-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 text-white placeholder-gray-400"
              placeholder="Enter software name"
              required
            />
          </div>

          {/* Description */}
          <div>
            <label className="block text-sm font-medium text-gray-300 mb-1">
              Description
            </label>
            <textarea
              name="description"
              rows={5}
              value={formData.description}
              onChange={handleInputChange}
              className="w-full p-3 rounded-lg bg-gray-800 border border-gray-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 text-white placeholder-gray-400"
              placeholder="Write your review here..."
              required
            />
          </div>

          {/* Rating */}
          <div>
            <label className="block text-sm font-medium text-gray-300 mb-1">
              Rating
            </label>
            <input
              type="number"
              name="rating"
              value={formData.rating}
              onChange={handleInputChange}
              min={1}
              max={5}
              className="w-full p-3 rounded-lg bg-gray-800 border border-gray-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 text-white placeholder-gray-400"
              placeholder="Rate 1 to 5"
              required
            />
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            className="w-full py-3 bg-indigo-600 hover:bg-indigo-700 rounded-lg font-semibold text-white transition-colors shadow-md"
          >
            Update Review
          </button>
        </form>
      </div>
      </div>
  );
}
